module.exports = __webpack_public_path__ + "img/ic_logo.3e4a286d.png";